import { useTypedParams } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import { BoxesTypePage } from '@sorare/gameplay/src/pages/my-cards/BoxesTypePage';

import { PageParams } from './__generated__/routeParams';

const NBABoxesPage = () => {
  const { type } = useTypedParams<PageParams>();
  return <BoxesTypePage type={type} sport={Sport.NBA} />;
};
export default NBABoxesPage;
